import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LightbulbOutlineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"lightbulb_outline"}/>
}
